import { useMemo } from "react";
import { Skeleton } from "@react-spectrum/s2";

import { useStories } from "@app/hooks/stories";
import { useBreadcrumbs } from "@app/components/Breadcrumbs";

import { StoriesListCard } from "./StoriesListCard";

import { style } from "@react-spectrum/s2/style" with { type: "macro" };

export const StoriesList = ({ limit = -1 }) => {
  const stories = useStories();

  useBreadcrumbs([{ label: "Stories", href: "/stories" }]);

  const storiesList = useMemo(
    () =>
      [...(stories?.data ?? [])]
        .reverse()
        .filter((item) => !!item.id)
        .slice(0, limit !== -1 ? limit : (stories?.data?.length ?? 0)),
    [stories.data],
  );

  // TODO: add empty states

  return (
    <div
      className={style({
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        justifyContent: "start",
        gap: 16,
        boxSizing: "border-box",
        width: "100%",
        height: "fit",
      })}
    >
      {stories.isPending &&
        new Array(3).fill(0).map((_, index) => (
          <Skeleton key={index} isLoading>
            <StoriesListCard
              UNSAFE_style={
                limit !== -1
                  ? { flexBasis: `calc(100% / ${limit} - 1rem)` }
                  : { flexBasis: 240 }
              }
            />
          </Skeleton>
        ))}
      {stories.isSuccess &&
        storiesList.map((story) => (
          <StoriesListCard
            key={story.id}
            storyId={story.id}
            story={story}
            UNSAFE_style={
              limit !== -1
                ? { flexBasis: `calc(100% / ${limit} - 1rem)` }
                : { flexBasis: 240 }
            }
          />
        ))}
    </div>
  );
};
